import { z } from "zod";
import { REVIEW_LIFECYCLES } from "@/features/reviews/review-vocabulary";

/// Legacy URL scope for /performance-reviews. The index is now a single unified
/// cycle list (FR-002); `scope` is deprecated but tolerated so old bookmarks and
/// notification/sidebar links (?scope=my-reviews, my-team, ...) still resolve
/// without a 404. The value is ignored by the unified list (FR-015).
export const REVIEW_SCOPES = ["my-reviews", "my-team", "peer", "cycles", "templates"] as const;
export type ReviewScope = (typeof REVIEW_SCOPES)[number];

/// `status` is the admin-only organizer for the cycle list: one tab per
/// lifecycle so drafts, active, and historical rounds no longer share one
/// cluttered list. URL-driven (S3) so a tab is deep-linkable and survives
/// refresh. Non-admins never see the tabs (their list is active-only from the
/// backend), so the param is inert for them. Defaults to `active`.
export const reviewsRouteSearchSchema = z
  .object({
    scope: z.enum(REVIEW_SCOPES).optional().catch(undefined),
    status: z.enum(REVIEW_LIFECYCLES).catch("active").default("active"),
  })
  .strict();
export type ReviewsRouteSearch = z.infer<typeof reviewsRouteSearchSchema>;
